export default __webpack_public_path__ + "static/media/7b873b219fa5f1fb16bd985fbc9da55f1576593738256.1dc586c2.webp";